/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getMerchantOvertimeConfiguration} from '../api'

 export const useQueryGetMerchantOvertimeConfiguration = createReactQueryHook('getMerchantOvertimeConfiguration', getMerchantOvertimeConfiguration)
